import { Badge, Tooltip } from '@qodo/design-system';
import { format } from 'date-fns';
import { Info } from 'lucide-react';
import { ENVIRONMENTS } from '../../consts/env';
import { useSidebar } from '../../ui/sidebar';
import { formatDate } from '../../utils/date';
import { getEnv } from '../../utils/env';

export const AppVersion = () => {
  const env = getEnv();
  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';
  const isStaging =
    env === ENVIRONMENTS.STAGING || env === ENVIRONMENTS.STAGING_NEW;

  const commitHash = import.meta.env.VITE_COMMIT_HASH || '-';
  const commitAuthor = import.meta.env.VITE_COMMIT_AUTHOR || '-';
  const buildTime = import.meta.env.VITE_BUILD_TIME || '-';
  const isDateValid = !isNaN(new Date(buildTime).getTime());
  const formattedDate = isDateValid && format(new Date(buildTime), 'P');
  const formattedTime = isDateValid && format(new Date(buildTime), 'HH:mm');
  const formattedFullDate = isDateValid
    ? formatDate(buildTime, 'PP, HH:mm')
    : '-';

  const tooltipContent = (
    <div className="flex flex-col gap-1">
      <div className="font-mono text-xs">
        <span className="font-bold">Build date: </span>
        {formattedFullDate}
      </div>
      <div className="font-mono text-xs">
        <span className="font-bold">Commit hash: </span>
        {commitHash}
      </div>
      <div className="text-xs">
        <span className="font-bold">Commit author: </span>
        {commitAuthor}
      </div>
    </div>
  );

  if (!isStaging) {
    return <></>;
  }

  return (
    <Tooltip content={tooltipContent}>
      <Badge variant="emphasis" size="lg" className="flex-col py-2 cursor-help">
        {isCollapsed ? (
          <Info size={16} className="text-purple-500" />
        ) : isDateValid ? (
          <>
            <span>{formattedDate}</span>
            <span>{formattedTime}</span>
          </>
        ) : (
          <span>No details (Staging information)</span>
        )}
      </Badge>
    </Tooltip>
  );
};
